/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function getAssociatedFormElements<ELEMENT extends Element>({
  tag,
  internals,
}: {
  tag: string;
  internals: ElementInternals;
}): ELEMENT[] {
  /*                                                                 */
  return Array.from(
    internals?.form?.elements ?? document.getElementsByTagName(tag.toUpperCase()),
  ).filter((ele): ele is ELEMENT => ele.tagName === tag.toUpperCase());
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function getAssociatedFormElementsByName<ELEMENT extends Element & { name: string }>(opts: {
  tag: string;
  name: string;
  internals: ElementInternals;
}): ELEMENT[] {
  /*                                                                                    */
  return getAssociatedFormElements<ELEMENT>(opts).filter((ele) => ele.name === opts.name);
}
